import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { theme } from 'styled-tools';
import { ifVariantEq } from '@/components/utils/style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var UIProgressRingDefaultProps = {
  size: 'medium',
  variant: 'default'
};
var UIProgressRingSize = {
  small: {
    size: 40,
    strokeWidth: 3
  },
  medium: {
    size: 60,
    strokeWidth: 4
  },
  large: {
    size: 92,
    strokeWidth: 4
  }
};

var size = function size(props) {
  return UIProgressRingSize[props.size].size;
};

var strokeWidth = function strokeWidth(props) {
  return UIProgressRingSize[props.size].strokeWidth;
};

var UIProgressRingAdapter = function UIProgressRingAdapter(_ref) {
  var children = _ref.children,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);

  var diameter = size(props);
  var radius = diameter / 2;
  var radiusWithoutStroke = radius - strokeWidth(props) / 2;
  var circumference = 2 * radiusWithoutStroke * Math.PI;
  var dashOffset = circumference - circumference * value;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("svg", {
      className: "UIProgressRing__svg",
      width: "100%",
      height: "100%",
      viewBox: "0 0 ".concat(diameter, " ").concat(diameter),
      version: "1.1",
      children: [/*#__PURE__*/_jsx("g", {
        className: "UIProgressRing__svg__group UIProgressRing__svg__group--background-ring",
        children: /*#__PURE__*/_jsx("circle", {
          cx: radius,
          cy: radius,
          r: radiusWithoutStroke
        })
      }), /*#__PURE__*/_jsx("g", {
        className: "UIProgressRing__svg__group UIProgressRing__svg__group--progress-ring",
        transform: "rotate(-90 ".concat(radius, " ").concat(radius, ")"),
        style: {
          transition: 'stroke-dashoffset 2s',
          strokeDasharray: circumference,
          strokeDashoffset: dashOffset,
          strokeLinecap: 'round'
        },
        children: /*#__PURE__*/_jsx("circle", {
          cx: radius,
          cy: radius,
          r: radiusWithoutStroke
        })
      })]
    }), children]
  }));
};

export var setProgressColor = function setProgressColor(value) {
  if (value <= 0.1) return theme('color.radicalRed');
  if (value > 0.1 && value <= 0.6) return theme('color.supernova');
  if (value > 0.6) return theme('color.emerald');
  return 'transparent';
};
var UIProgressRing = styled(UIProgressRingAdapter).withConfig({
  displayName: "UIProgressRing",
  componentId: "sc-1qu4soq-0"
})(["position:relative;display:flex;width:", "px;height:", "px;justify-content:center;align-items:center;.UIProgressRing__svg{position:absolute;top:0;left:0;}.UIProgressRing__svg__group{fill:none;stroke-width:", ";&.UIProgressRing__svg__group--background-ring{stroke:#dfe2e6;}&.UIProgressRing__svg__group--progress-ring{", " ", "}}"], size, size, strokeWidth, function (_ref2) {
  var value = _ref2.value;
  return ifVariantEq('default', css(["stroke:", ";"], setProgressColor(value)));
}, ifVariantEq('primary', css(["stroke:", ";"], theme('color.primary'))));
UIProgressRing.defaultProps = UIProgressRingDefaultProps;
export default UIProgressRing;